import { StyleSheet } from 'react-native'
import { Metrics } from 'APP/Themes'

export default StyleSheet.create({
  trackerStatusWrapper: {
    marginTop: -Metrics.baseMargin * 1.2,
    marginHorizontal: Metrics.baseMargin * 1.5,
  },
})
